import { render, staticRenderFns } from "./ArtistForm.vue?vue&type=template&id=7bddefe8&scoped=true&"
import script from "./ArtistForm.vue?vue&type=script&lang=js&"
export * from "./ArtistForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=7bddefe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bddefe8",
  null
  
)

export default component.exports